module.exports = __webpack_public_path__ + "media/images/spinner-5c0c2ff60de14006aa7452fa9492710b.gif";